// Shared constants for the advertisement pop-up (admin form, admin preview,
// retailer dialog). Kept in a leaf module so the preview can import them
// without a circular dependency on the form.

export const MAX_POPUP_IMAGES = 4;

// One recommended size per platform. The retailer pop-up renders every image
// inside a frame with this exact ratio (object-fit: cover), so an upload of
// this size shows edge-to-edge with no cropping on any screen.
export const POPUP_IMAGE_SPECS = {
  web: { width: 1200, height: 675, ratio: "16 / 9", label: "1200 × 675 px (16:9)" },
  mobile: { width: 1080, height: 1350, ratio: "4 / 5", label: "1080 × 1350 px (4:5)" },
} as const;

export type PopupRedirectType = "none" | "url" | "masterSearch";

export const REDIRECT_LABELS: Record<PopupRedirectType, string> = {
  none: "Just close the pop-up",
  url: "Open a link",
  masterSearch: "Show selected products",
};

export const POPUP_CTA_LABELS: Record<PopupRedirectType, string> = {
  none: "Close",
  url: "Open link",
  masterSearch: "View products",
};
